import React from 'react'

export const DegreesSymbol = () => (
  <>
    {' '}
    C&deg;
  </>
)
